import { ToggleButton } from '@mui/material';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import { AutogiroMandateStatusEnum } from 'src/shared/models/enums/autogiroMandateStatus.enum';
import { AutogiroStatusTabItem, autogiroStatusTabs } from './autogiroStatusTabs';

type AutogiroOverviewStatusesProps = {
  initialValue: AutogiroMandateStatusEnum[];
  callback: (statuses: AutogiroMandateStatusEnum[] | undefined) => void;
};

export const AutogiroOverviewStatuses = (props: AutogiroOverviewStatusesProps) => {
  const { initialValue, callback } = props;
  const { t } = useTranslation(['invoice']);

  const allKeys = useMemo(() => autogiroStatusTabs.map((x) => x.key), []);

  const initialKeys = useMemo(() => {
    if (initialValue && initialValue.length) {
      return autogiroStatusTabs.filter((tab) => tab.values.some((v) => initialValue.includes(v))).map((tab) => tab.key);
    }
    return allKeys;
  }, [allKeys, initialValue]);

  const [selectedKeys, setSelectedKeys] = useState<string[]>(initialKeys);

  const handleKeys = (event: React.MouseEvent<HTMLElement>, newKeys: string[]) => {
    const selectedTabs: AutogiroStatusTabItem[] = autogiroStatusTabs.filter((item) => newKeys.includes(item.key));
    const values = Array.from(new Set(selectedTabs.flatMap((tab) => tab.values)));
    setSelectedKeys(newKeys);
    callback(values.length === allKeys.length ? undefined : values);
  };

  return (
    <FormFieldset legend={t('invoice:autogiro.tableHeader.status')} noPadding>
      <StyledToggleButtonGroup value={selectedKeys} onChange={handleKeys} color='primary' size='small'>
        {autogiroStatusTabs.map((x) => (
          <ToggleButton value={x.key} key={x.key}>
            {t(x.label)}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
